import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { getAddressLaoProvince } from "../redux/handlers/master/getAddressLaoProvince.handler";
import { getAddressLaoDistrict } from "../redux/handlers/master/getAddressLaoDistrict.handler";
import { getAddressLaoVillage } from "../redux/handlers/master/getAddressLaoVillage.handler";
import AddressSelect, { useAddressRows } from "./AddressSelect";
export default function LaoAddressSelect(param) {
    var values = param.values, onChange = param.onChange;
    var provinces = useAddressRows(getAddressLaoProvince, "getAddressLaoProvinceReducer");
    var province = provinces.rows.find(function(row) {
        return String(row.lao_province_id) === String(values.sh_branch_laoprovince_id);
    });
    var provinceid = province === null || province === void 0 ? void 0 : province.lao_province_id;
    var districts = useAddressRows(getAddressLaoDistrict, "getAddressLaoDistrictReducer", provinceid, undefined, Boolean(provinceid));
    var district = districts.rows.find(function(row) {
        return String(row.lao_district_id) === String(values.sh_branch_laodistrict_id);
    });
    var districtid = district === null || district === void 0 ? void 0 : district.lao_district_id;
    var children = useAddressRows(getAddressLaoVillage, "getAddressLaoVillageReducer", provinceid, districtid, Boolean(provinceid && districtid));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "แขวง",
                value: values.sh_branch_laoprovince_id,
                source: provinces,
                idKey: "lao_province_id",
                nameKey: "lao_province_name",
                onChange: function(option) {
                    var _option_value;
                    return onChange({
                        sh_branch_laoprovince_id: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null,
                        sh_branch_laodistrict_id: null,
                        sh_branch_laovillage_id: null
                    });
                }
            }),
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "เมือง",
                value: values.sh_branch_laodistrict_id,
                source: districts,
                idKey: "lao_district_id",
                nameKey: "lao_district_name",
                disabled: !provinceid,
                onChange: function(option) {
                    var _option_value;
                    return onChange({
                        sh_branch_laodistrict_id: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null,
                        sh_branch_laovillage_id: null
                    });
                }
            }),
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "บ้าน",
                value: values.sh_branch_laovillage_id,
                source: children,
                idKey: "lao_village_id",
                nameKey: "lao_village_name",
                disabled: !districtid,
                onChange: function(option) {
                    var _option_value;
                    return onChange({
                        sh_branch_laovillage_id: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null
                    });
                }
            })
        ]
    });
}
